// extracted by mini-css-extract-plugin
export default {"boss":"Boss_boss__-h0F-","image":"Boss_image__6wEQd","floating":"Boss_floating__0Avp-","intro":"Boss_intro__W1ChE"};